'use client';



interface BackgroundGridProps {
  showGradients?: boolean;
  gridOpacity?: number;
}

export function BackgroundGrid({ gridOpacity = 0.06 }: BackgroundGridProps) {
  return (
    <div
      className="background-grid"
      style={{
        position: 'absolute',
        inset: 0,
        backgroundImage: `
          linear-gradient(to right, var(--border) 1px, transparent 1px),
          linear-gradient(to bottom, var(--border) 1px, transparent 1px)
        `,
        backgroundSize: '60px 60px',
        opacity: gridOpacity,
        pointerEvents: 'none',
      }}
      aria-hidden="true"
    />
  );
}
